import { ref } from 'vue'

import { getPreference } from '@/contexts/preferences/Preferences.services'
import { type PreferenceValue, PreferenceType } from '@/contexts/preferences/Preferences.interfaces'
import type { ServiceResponse } from '@/contexts/shared/service-response/ServiceResponse.interfaces'

export const usePreference = (key: string, type: PreferenceType) => {
  const preference = ref<PreferenceValue | null>(null)

  const fetchPreference = async (): Promise<ServiceResponse<PreferenceValue>> => {
    const response = await getPreference(key, type)

    if (response.ok) {
      preference.value = response.data
    }

    return response
  }

  return { preference, fetchPreference }
}
